<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="accounting-filter">
        <div class="card" style="overflow: inherit">
            <div class="card-header bg-transparent" id="headingOne">
            <div class="card-title collapsed" data-toggle="collapse"
                data-target="#filterForm"
                aria-controls="filterForm">
                {{ $t("label.search") }}
            </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#accounting-filter">
            <div class="card-body">
                <form @submit.prevent="handleFilterHolidays" id="transaction-filter-form">
                    <kt-form-row>
                        <kt-col xs="12" sm="6">
                            <kt-form-group>
                            <kt-form-label for="from_date">
                                {{ $t('label.from_date') }}
                            </kt-form-label>
                            <button id="reset_from_date"
                                    @click="clearFromDate"
                                    type="button"
                                    class="btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                format="YYYY-MM-DD"
                                display-format="dddd jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="from_date"
                                name="from_date"
                                v-model="query.from_date"
                                type="date" />
                                </kt-form-group>
                        </kt-col>
                        <kt-col xs="12" sm="6">
                            <kt-form-group>
                            <kt-form-label for="to_date">
                                {{ $t('label.to_date') }}
                            </kt-form-label>
                            <button id="reset_to_date"
                                    @click="clearToDate"
                                    type="button"
                                    class="btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                format="YYYY-MM-DD"
                                display-format="dddd jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="to_date"
                                name="to_date"
                                v-model="query.to_date"
                                type="date"
                            />
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>
                    <kt-row>
                        <kt-col xs="12" sm="6" md="6">
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-col>
                    </kt-row>
                </form>
            </div>
            </div>
        </div>
        </div>
    </kt-panel>
</template>

<script>

export default {
  name: "HolidayFilter",
  data() {
    return {
      query: {
        from_date: "",
        to_date: "",
      }
    };
  },
  methods: {
    handleFilterHolidays() {        
        this.$emit('holiday-filtered', this.query);
    },
    clearFromDate() {
      if (this.query.from_date) {
        this.query.from_date = null;
      }
    },
    clearToDate() {
      if (this.query.to_date) {
        this.query.to_date = null;
      }
    },
  }
}
</script>